import { Controller } from "@hotwired/stimulus"

// tailwindcss-stimulus-componentsを参考に実装
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { index: { type: Number, default: 0 } }

  connect() {
    // タブパネルが存在しない場合は終了
    if (this.tabTargets.length === 0 || this.panelTargets.length === 0) return

    // デフォルトのタブを選択
    this.showTab()
  }

  // indexValueが変更されたときに呼ばれる
  indexValueChanged() {
    this.showTab()
  }

  // タブクリック時のハンドラー
  change(event) {
    event.preventDefault()
    // クリックされたタブのインデックスを取得
    const clickedTabIndex = this.tabTargets.indexOf(event.currentTarget)
    if (clickedTabIndex !== -1) {
      this.indexValue = clickedTabIndex
    }
  }

  // 次のタブに移動するメソッド
  nextTab(event) {
    event.preventDefault()
    // 最後のタブでなければ次のタブに移動
    if (this.indexValue < this.tabTargets.length - 1) {
      this.indexValue++

      // タブコンテナの位置までスムーズにスクロール
      const tabsContainer = this.element
      window.scrollTo({
        top: tabsContainer.offsetTop - 20, // 少し上部にマージンを設ける
        behavior: 'smooth' // スムーズなアニメーション
      })
    }
  }

  // 前のタブに移動するメソッド
  prevTab(event) {
    event.preventDefault()
    // 最初のタブでなければ前のタブに移動
    if (this.indexValue > 0) {
      this.indexValue--

      // タブコンテナの位置までスムーズにスクロール
      const tabsContainer = this.element
      window.scrollTo({
        top: tabsContainer.offsetTop - 20, // 少し上部にマージンを設ける
        behavior: 'smooth' // スムーズなアニメーション
      })
    }
  }

  // 選択されたタブとパネルを表示する
  showTab() {
    this.tabTargets.forEach((tab, i) => {
      const selected = this.indexValue === i

      // アクティブなタブのスタイルを設定
      if (selected) {
        tab.classList.add("border-blue-500", "text-blue-700", "bg-blue-50")
        tab.classList.remove("text-gray-500", "hover:text-gray-700")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("border-blue-500", "text-blue-700", "bg-blue-50")
        tab.classList.add("text-gray-500", "hover:text-gray-700")
        tab.setAttribute("aria-selected", "false")
      }
    })

    // パネルの表示/非表示を切り替え
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = this.indexValue !== i
    })
  }
}
